import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './pages/index';
import reportWebVitals from './reportWebVitals';
import GlobalStyles from './GlobalStyles';
import { IntlWrapper } from './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <IntlWrapper>
      <BrowserRouter>
        <GlobalStyles />
        <App />
      </BrowserRouter>
    </IntlWrapper>
  </React.StrictMode>
);

reportWebVitals();
